import React from "react";
import axios from "axios";
import Chart from "react-apexcharts";
import ReportsError from './ReportsError';
import {
    getGraphColours,
    capitalizationWithExceptions
} from './Utilities';

class ReportsDailyRegistrations extends React.Component {
    constructor(props) {
        super(props);

        const endpoint = "login/stats/timeline?turnoffdebug=1";

        this.state = {
            url: `react/process?endpoint=${endpoint}&hourly_cutoff=0`,
            services: {},
            isLoading: true,
            error: null
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        axios.get(this.state.url)
            .then(response => this.formatData(response.data))
            .catch(err => {
                console.error("Fetch error:", err);
                this.setState({ isLoading: false, error: "Failed to load data" });
            });
    }

    formatData(data) {
        const error = data?.error || null;
        this.setState({
            services: data,
            error: error?.message,
            isLoading: false
        });
    }

    render() {
        const { isLoading, services, error } = this.state;
        const currentView = this.props.view;

        if (isLoading) {
            return (
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="loading col-md-4">
                        <div className="react-loading big"></div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            );
        }

        if (Object.values(services).length === 0) {
            return <ReportsError error={error} />;
        }

        return currentView === "graph"
            ? this.renderGraph()
            : this.renderTable();
    }

    renderTable() {
        const { services } = this.state.services;

        return (
            <div>
                {services.map(service => (
                    <div key={service.service} className="table-responsive row mb-3">
                        <h3>{capitalizationWithExceptions(service.service)}</h3>
                        <table className="table table-striped table-nowrap table-centered mb-3">
                            <thead>
                                <tr>
                                    {service.range.map(date => (
                                        <td key={service.service + date.Date}>
                                            <strong>{date.Date}</strong>
                                        </td>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {service.range.map(date => (
                                        <td key={date.Count + date.Date}>
                                            {date.Count}
                                        </td>
                                    ))}
                                </tr>
                            </tbody>
                        </table>
                        <p>
                            Total {capitalizationWithExceptions(service.service)} registrations for period:{" "}
                            {service.ServiceTotal}
                        </p>
                        <hr />
                    </div>
                ))}
                <div className="table-controls">
                    <h4>Total overall registrations for period: {this.state.services.PeriodTotal}</h4>
                </div>
            </div>
        );
    }

    renderGraph() {
        const { services } = this.state.services;

        const xaxis = services[0]?.range?.map(r => r.Date) || [];
        const graphData = services.map(service => ({
            name: capitalizationWithExceptions(service.service),
            data: service.range.map(r => r.Count)
        }));

        const params = {
            options: {
                chart: {
                    id: "report-line-chart"
                },
                xaxis: {
                    categories: xaxis
                },
                colors: getGraphColours()
            },
            series: graphData
        };

        return (
            <div className="row">
                <div className="mixed-chart">
                    <Chart
                        options={params.options}
                        series={params.series}
                        type="line"
                        width="75%"
                    />
                </div>
            </div>
        );
    }
}

export default ReportsDailyRegistrations;
